import { createSelector } from 'reselect';
import { getHasOpenActivitySet } from './getHasOpenActivitySet';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';

/**
 * Determines if there is an open job running.
 *
 * For APM flow: true when there's a synthetic labor ticket (from opdash display).
 * For all other flows: delegates to getHasOpenActivitySet (Redux activity set when
 * legacy, or labor-ticket–synthetic set when postLaborUpdatesOnNats).
 *
 * This is the primary selector for determining if a job is currently running.
 */
const getHasOpenJob = createSelector(
  [getHasOpenActivitySet, getCurrentLaborTicket, getIsApmERPJobFlow],
  (hasOpenActivitySet, currentLaborTicket, isApmERPJobFlow) => {
    if (isApmERPJobFlow) {
      return !!currentLaborTicket;
    }
    // Remove duplicated NATS/paused-setup checks because getHasOpenActivitySet already owns them.
    return hasOpenActivitySet;
  }
);

export { getHasOpenJob };
